// extracted by mini-css-extract-plugin
export default {"primaryColorBase":"#1e3282","primaryColorLight":"#273d92","primaryColorLighter":"#4860be","primaryColorLightest":"#8593ce"};